import { Loading } from '@optimization/ssi-common';
import { ReactElement } from 'react';
import useDelayedIsLoading from './utils/use-delayed-is-loading';
import useGlobalIsError from './utils/use-global-is-error';
import useGlobalIsLoading from './utils/use-global-is-loading';
import useLoadingText from './utils/use-loading-text';
import { globalLoadingProgressPercentSelector } from './global-loading-slice';
import { useAppSelector } from '@/app/hooks';

const GlobalLoading = (): ReactElement => {
  const isLoading = useGlobalIsLoading();
  const isError = useGlobalIsError();
  const loadingText = useLoadingText({ isLoading });
  const progressPercent = useAppSelector(globalLoadingProgressPercentSelector);
  const delayedIsLoading = useDelayedIsLoading({ isLoading });

  return (
    <Loading
      isLoading={delayedIsLoading}
      isError={isError}
      loadingText={loadingText}
      progressPercent={progressPercent}
    />
  );
};

export default GlobalLoading;
